/* PRISON — collection descriptions. Progressive enhancement; original HTML is server-rendered. */
(() => {
  'use strict';
  const selector = '[id^="shopify-section-"][id$="__prison_collection_description"]';
  const clean = (value) => (value || '').replace(/\s+/g, ' ').trim();
  const excerpt = (value, limit = 220) => {
    if (value.length <= limit) return value;
    const cut = value.slice(0, limit + 1);
    const boundary = cut.lastIndexOf(' ');
    return cut.slice(0, boundary > limit * 0.6 ? boundary : limit).replace(/[,:;\s]+$/, '') + '…';
  };

  function enhance(section) {
    if (section.dataset.prisonEditorial === 'ready') return;
    const source = section.querySelector('.hero__text, .hero__richtext');
    if (!source) return;
    const originalText = clean(source.textContent);
    if (!originalText && !source.querySelector('img, video, iframe, table')) {
      section.hidden = true;
      return;
    }

    const story = document.createElement('div');
    story.className = 'prison-collection-editorial';
    const header = document.createElement('header');
    header.className = 'prison-collection-editorial__header';
    const eyebrow = document.createElement('p');
    eyebrow.className = 'prison-collection-editorial__eyebrow';
    eyebrow.textContent = 'Sobre a coleção';
    const first = source.firstElementChild;
    const firstHeading = first && /^H[12]$/.test(first.tagName) ? first : null;
    const title = document.createElement('h2');
    title.className = 'prison-collection-editorial__title';
    title.textContent = firstHeading ? clean(firstHeading.textContent) : clean(document.querySelector('main h1')?.textContent) || 'PRISON®';
    header.append(eyebrow, title);

    const body = document.createElement('div');
    body.className = 'prison-collection-editorial__body';
    const content = document.createElement('div');
    content.className = 'prison-collection-editorial__content';
    content.id = section.id + '-editorial-content';
    /* Move, never fetch or recreate, the original description nodes. */
    if (firstHeading) {
      // Preserve links/formatting in an existing heading instead of duplicating it.
      if (firstHeading.id) title.id = firstHeading.id;
      title.replaceChildren(...Array.from(firstHeading.childNodes));
      firstHeading.remove();
    }
    content.append(...Array.from(source.childNodes));
    const paragraphs = Array.from(content.querySelectorAll('p')).filter((node) => clean(node.textContent));
    const text = clean(content.textContent);
    const intro = clean(paragraphs[0]?.textContent) || text;
    const complex = content.querySelector('h2, h3, h4, h5, h6, ul, ol, dl, table, img, video, iframe');
    const collapsible = text.length > 240 || paragraphs.length > 1 || Boolean(complex);
    const blockAttributes = source.getAttribute('data-shopify-editor-block');
    if (blockAttributes) body.setAttribute('data-shopify-editor-block', blockAttributes);

    if (collapsible && intro) {
      const preview = document.createElement('p');
      preview.className = 'prison-collection-editorial__preview';
      preview.textContent = excerpt(intro);
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'prison-collection-editorial__toggle';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', content.id);
      const label = document.createElement('span');
      label.textContent = 'Ver mais';
      const icon = document.createElement('span');
      icon.className = 'prison-collection-editorial__icon';
      icon.setAttribute('aria-hidden', 'true');
      button.append(label, icon);
      content.hidden = true;
      body.append(preview, content, button);
      button.addEventListener('click', () => {
        const expand = button.getAttribute('aria-expanded') !== 'true';
        const wasAbove = story.getBoundingClientRect().top < 0;
        content.hidden = !expand;
        preview.hidden = expand;
        button.setAttribute('aria-expanded', String(expand));
        label.textContent = expand ? 'Ver menos' : 'Ver mais';
        if (!expand && wasAbove) {
          story.scrollIntoView({ block: 'start', behavior: 'instant' });
          button.focus({ preventScroll: true });
        }
      });
      /* In-page links to a heading inside the description remain usable. */
      const revealHash = () => {
        if (!location.hash) return;
        let target;
        try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); }
        catch (_) { return; }
        if (target && content.contains(target) && content.hidden) {
          button.click();
          target.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      };
      window.addEventListener('hashchange', revealHash);
      // Section editor can replace this node without a full navigation.
      section.addEventListener('shopify:section:unload', () => window.removeEventListener('hashchange', revealHash), { once: true });
      requestAnimationFrame(revealHash);
    } else {
      body.append(content);
    }
    story.append(header, body);
    section.replaceChildren(story);
    section.dataset.prisonEditorial = 'ready';
    section.hidden = false;
  }

  const init = (scope = document) => {
    if (scope instanceof Element && scope.matches(selector)) enhance(scope);
    scope.querySelectorAll(selector).forEach(enhance);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
